export default __webpack_public_path__ + "static/media/Broken_image.f37198be.svg";